import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { gsap } from 'gsap';
import { WelcomeService } from '../../core/services/welcome.service';

@Component({
  selector: 'app-welcome-page',
  templateUrl: './welcome-page.component.html',
  styleUrl: './welcome-page.component.scss',
  standalone: false,
})
export class WelcomePageComponent implements AfterViewInit {
  @ViewChild('innerAnimDiv') innerAnimDivRef!: ElementRef;
  @ViewChild('outerAnimDiv') outerAnimDivRef!: ElementRef;

  constructor(
    private router: Router,
    private welcomeService: WelcomeService,
  ) {}

  ngAfterViewInit(): void {
    if (this.outerAnimDivRef && this.innerAnimDivRef) {
      this.animateContent();
    }
  }

  animateContent(): void {
    const outerElement = this.outerAnimDivRef.nativeElement;
    const innerElement = this.innerAnimDivRef.nativeElement;

    gsap.fromTo(
      outerElement,
      { opacity: 0 },
      { opacity: 1, duration: 2, ease: 'power2.out' },
    );

    gsap.fromTo(
      innerElement,
      { scale: 0.8, opacity: 0 },
      {
        scale: 1,
        opacity: 1,
        duration: 1,
        ease: 'spring(1, 120, 0.5, 0.01)',
      },
    );
  }

  onStartClick(event: Event): void {
    event.preventDefault();

    if (this.outerAnimDivRef) {
      const elementToAnimate = this.outerAnimDivRef.nativeElement;
      gsap.to(elementToAnimate, {
        opacity: 0,
        y: -90,
        duration: 0.5,
        ease: 'power2.in',
        onComplete: () => {
          this.welcomeService.markSeen();
          this.router.navigate(['/factory']);
        },
      });
    } else {
      //this.welcomeService.markSeen()
      //this.router.navigate(['/factory']);
    }
  }
}
